import {Component, OnDestroy, OnInit} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {RepublicaMovilService} from '../../services/republica-movil.service';
import {RmOrderService} from '../../services/rm-order.service';
import {RmDraftService} from '../../services/rm-draft.service';
import { RmNormalizadorService } from '../../services/rm-normalizador.service';
import { orderType } from 'src/app/shared/constantes';
import { AlertDialogComponent } from 'src/app/shared/components/alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DigoService } from 'src/app/services/digo.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-rm-modal-save',
    templateUrl: './rm-modal-save.component.html',
    styleUrls: ['./rm-modal-save.component.css', '../../../../assets/css/rm-theme.css'],
    standalone: false
})
export class RmModalSaveComponent implements OnInit, OnDestroy {
    protected order;
    protected preventDestroy = false;
    protected ratesMobile;
    public loading: boolean = false;
    private thereIsCoverage: boolean;
    private typeOrder: string;
    public classClickedNo: boolean = false;
    public classClickedYes: boolean = false;
    public pdv;
    private allSubscription: Subscription[] = [];

    constructor(
        protected modalService: NgbModal,
        private orderService: RmOrderService,
        protected draftService: RmDraftService,
        protected rmService: RepublicaMovilService,
        private normalizadorService: RmNormalizadorService,
        private matdialog: MatDialog,
        private digoService: DigoService
    ) {
        this.allSubscription.push(this.orderService.getOrder()
            .subscribe((order) => {
                this.order = order;
            })
        );

        this.allSubscription.push(this.rmService.getPreventDestroy()
            .subscribe((data: boolean) => {
                this.preventDestroy = data;
            })
        );

        this.allSubscription.push(this.rmService.getRatesMobile()
            .subscribe((data) => {
                this.ratesMobile = data;
            })
        );

        this.allSubscription.push(this.normalizadorService.getThereIsCoverage()
            .subscribe((data) => {
                this.thereIsCoverage = data;
            })
        );

        this.allSubscription.push(this.rmService.getTypeOrder()
            .subscribe((data: any) => {
                if (data != null) {
                    this.typeOrder = data;
                }
            })
        );
            
        this.allSubscription.push(this.digoService.getPDV()
            .subscribe(data => {
                if (data) {
                    this.pdv = data;
                }
            })
        );
    }

    ngOnInit(): void {

    }

    closeModal() {
        this.modalService.dismissAll();
        this.draftService.continueNavigation.next(false);
    }

    onRemoveDraft() {
        if (!this.openModalUsuarioDemo()) {
            this.loading = true;
            if (this.order && this.order.order_id && this.order.order_id !== '') {
                this.rmService.removeOrder(this.order.order_id)
                    .subscribe(response => {
                        console.log('Order borrada');
                        this.loading = false;
                        this.modalService.dismissAll();
                    }, error => {
                        console.log('Error al borrar la order');
                        this.loading = false;
                        this.modalService.dismissAll();
                        this.draftService.continueNavigation.next(true)
                    }, () => this.draftService.continueNavigation.next(true));
            } else {
                this.modalService.dismissAll();
                this.draftService.continueNavigation.next(true);
            }
        }
    }

    onSaveDraft() {
        if (!this.openModalUsuarioDemo()) {
            if (!this.loading && !((this.typeOrder === orderType.CONVERGENT || this.typeOrder === orderType.BROADBAND) && !this.thereIsCoverage)) {
                this.loading = true;
                // mandamos señal para que RmComponent meta los ultimos cambios en el order
                this.draftService.updateDraft(true);
                let info = {
                    trace: 'saveDraft' + (navigator ? ('/' + navigator.userAgent) : ''),
                    timestamp: new Date().toISOString()
                }
                // persistimos el draft
                this.orderService.createOrder(true, info)
                    .subscribe((data) => {},
                    () => {
                        this.loading = false;
                        this.modalService.dismissAll();
                        this.draftService.updateDraft(false);
                        this.draftService.continueNavigation.next(true);
                    }, () => {
                        this.loading = false;
                        this.modalService.dismissAll();
                        this.draftService.updateDraft(false);
                        this.draftService.continueNavigation.next(true);
                    });
            } else {
                this.modalService.dismissAll();
                this.draftService.continueNavigation.next(true);
            }
        }
    }

    openModalUsuarioDemo(): boolean {
        if (this.pdv.permissions.SAMPLE_MODE && this.pdv.permissions.SAMPLE_MODE === 'SAMPLE') {
            this.modalService.dismissAll();
            this.matdialog.open(AlertDialogComponent, {
                data: {message: 'Usuario demostración. No se puede guardar o eliminar un borrador'}
            });
            this.draftService.continueNavigation.next(true);
            return true;
        }
        return false
    }

    ngOnDestroy() {
        if (this.allSubscription && this.allSubscription.length) {
            this.allSubscription.map(subs => subs.unsubscribe());
        }
    }
}
